<mat-nav-list>
  <mat-list-item>
    <a [routerLink]="['']">
      <mat-icon mat-list-icon class="icon">home</mat-icon>
      <span class="full-width" *ngIf="isExpanded || isShowing">Accueil</span>
    </a>
  </mat-list-item>
  <mat-list-item>
    <a [routerLink]="['/list-bc']" (click)= "list_bc()">
      <mat-icon mat-list-icon class="icon"> library_books</mat-icon>
      <span class="full-width" *ngIf="isExpanded || isShowing">Liste BC</span>
    </a>
  </mat-list-item>
  <mat-list-item>
    <a [routerLink]="['/create-bc']" >
      <mat-icon mat-list-icon class="icon">library_add</mat-icon>
      <span class="full-width" *ngIf="isExpanded || isShowing">Création&nbsp;BC</span>
    </a>
  </mat-list-item>

  <mat-list-item>
    <a [routerLink]="['/list-bp']" (click)= "list_bp()">
      <mat-icon mat-list-icon class="icon">content_paste</mat-icon>
      <span class="full-width" *ngIf="isExpanded || isShowing">Liste facture</span>
    </a>
  </mat-list-item>

  <mat-list-item *ngIf="bpDisplayState && environment">
    <a [routerLink]="['/select-bc-for-create-bp']" (click)="add_bp()">
      <mat-icon mat-list-icon class="icon">note_add</mat-icon>
      <span class="full-width" *ngIf="isExpanded || isShowing">Ajout&nbsp; facture</span>
    </a>
  </mat-list-item>

  <mat-list-item *ngIf="droitInterface">
    <a [routerLink]="['/interface']" >
      <mat-icon mat-list-icon class="icon">import_export</mat-icon>
      <span class="full-width" *ngIf="isExpanded || isShowing">Interface</span>
    </a>
  </mat-list-item>

  <mat-list-item>
    <a [routerLink]="['/dashboard']">
      <mat-icon mat-list-icon class="icon">dashboard</mat-icon>
      <span class="full-width" *ngIf="isExpanded || isShowing">Dashboard</span>
    </a>
  </mat-list-item>
  <!--
  <mat-list-item>
    <a (click)="refresh()" matTooltip="Silent refresh">
      <mat-icon mat-list-icon class="icon" matTooltip="Refresh Google Token">autorenew</mat-icon>
    </a>
  </mat-list-item>
  -->
    <a style="position: fixed; bottom: 0; font-size:smaller; color: #F39800;" matTooltip={{version}}> V {{versionSmall}}</a>
</mat-nav-list>
